import { TypePolicy } from '@apollo/client';

const EncounterTask: TypePolicy = {
  keyFields: ['encounterTaskId'],
};

export default EncounterTask;
